(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.financials-share-valuation', [
    'pp.widgets-templates',
    'pp.filters.numbers',
    'pp.widgets.expandable-toggle',
    'pp.values.glossary',
    'pp.components.tooltip'
]);

ngModule.directive('ppFinancialsShareValuation', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/financials-share-valuation/financials-share-valuation.tpl.html',
        scope: {
            property: '<ppFinancialsShareValuation',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', 'ppUtil', 'glossary', function ($scope, ppUtil, glossary) {
            var vm = this;

            // -- initial state

            vm.purchaseCostsBreakdownVisible = false;
            vm.deferredTaxDesc = glossary.deferredTax;

            // -- util functions

            // -- api
            vm.toggleExpandBreakdown = function () {
                vm.purchaseCostsBreakdownVisible = !vm.purchaseCostsBreakdownVisible;
            };

            // -- scope bindings

            // -- main

            vm.$onInit = function () {
                if (ppUtil.hasPathIn(vm.property, 'valuation')) {
                    vm.latestPropertyValue = vm.property.valuation.propertyPriceIv;
                    vm.latestPropertyValueVpv = vm.property.valuation.propertyPriceVpv;
                }
            };

        }]
    };
}]);
})(window, window.angular);